import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Flame } from "lucide-react";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = location.hash || window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(match[1]);

        // Clear the fragment
        try { window.history.replaceState(null, "", window.location.pathname); } catch { /* ignore */ }

        api.post("/auth/google-session", { session_id: sessionId })
            .then((res) => {
                // Persist session_token in localStorage as fallback for iframe/third-party-cookie contexts
                if (res.data?.token) {
                    localStorage.setItem("tc_token", res.data.token);
                }
                try { sessionStorage.setItem("tc_had_session", "1"); } catch { /* ignore */ }
                setUser(res.data.user);
                navigate(res.data.user.onboarded ? "/dashboard" : "/onboarding", { replace: true, state: { user: res.data.user } });
            })
            .catch(() => {
                navigate("/login", { replace: true });
            });
    }, [location.hash, navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center cream-grain" data-testid="auth-callback">
            <div className="flex flex-col items-center gap-3">
                <Flame className="w-6 h-6 text-brand-spark animate-flicker" strokeWidth={1.5} />
                <div className="font-serif italic text-brand-darkPurple/70">lighting the lantern…</div>
            </div>
        </div>
    );
}
